var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../../../I18N";
import { availableLanguages } from "../../../../../../../shared/language";

import { Button, Sidepanel } from "../../../../../Components/UI";
import { PDF } from "../../../../../Components/PDFViewer";







const PDFSidepanel = ({ showSidepanel, setShowSidepanel, entity }) => {var _entity$documents;
  const defaultLanguage = availableLanguages.find((lang) => lang.key === (entity === null || entity === void 0 ? void 0 : entity.language));
  const mainDocument =
  (entity === null || entity === void 0 ? void 0 : (_entity$documents = entity.documents) === null || _entity$documents === void 0 ? void 0 : _entity$documents.find((document) => document.language === (defaultLanguage === null || defaultLanguage === void 0 ? void 0 : defaultLanguage.ISO639_3))) ||
  (entity === null || entity === void 0 ? void 0 : entity.documents) && entity.documents[0];

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      size: "large",
      title: entity === null || entity === void 0 ? void 0 : entity.title,
      closeSidepanelFunction: () => setShowSidepanel(false) }, void 0, /*#__PURE__*/

    _jsx(Sidepanel.Body, { className: "flex-grow overflow-y-auto" }, void 0,
    mainDocument && /*#__PURE__*/_jsx(PDF, { fileUrl: `/api/files/${mainDocument.filename}` })
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "sticky bottom-0 flex justify-end gap-2 px-4 py-2 bg-white border border-b-0 border-l-0 border-r-0 border-gray-200 border-t-1" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "outline",
      onClick: () => {
        setShowSidepanel(false);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Close")
    )
    )
    )
    ));

};

export { PDFSidepanel };